import React, { useContext } from 'react';
import { ThemeContext } from '../../../Context/ThemeContext';

const ThemeToggleButton = () => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      className={`theme-toggle ${isDarkMode ? 'dark' : 'light'}`}
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      <div className="toggle-thumb">
        <span className="icon">{isDarkMode ? '🌙' : '☀️'}</span>
      </div>
    </button>
  );
};

export default ThemeToggleButton;